import { useDownloadURL } from "react-firebase-hooks/storage";
import { ref } from "firebase/storage";

import { storage } from "@/config/firebaseConfig";

/**
 * The signed-in member's avatar from Storage, shared by the sidebar user
 * menu and the desktop top bar so both read the same file.
 */
export function useMemberAvatarUrl(uid: string | undefined): string | undefined {
  const [url] = useDownloadURL(
    uid ? ref(storage, `businessMembersAvatars/${uid}/profile_image`) : undefined,
  );
  return url;
}
